import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
let env = process.env.REACT_APP_API_BASE_URL;


export const allotVehicle = async (data) => {
    const res = await requestInstance
      .put(`${env}${API_ENDPOINT.operations.allotApi}`, data)
      .catch((err) => err.response);
    return setCurrentUser(res);
  };

  export const availableVehicleService = async (payload) => {
    const payloadData = {
      search: payload?.search || "",
      id:  payload?.id,
    };

    let url = "";
    if(payload?.id){
      url = `${env}${API_ENDPOINT.operations.availableVehicleApi}?tripId=${payloadData?.id}&search=${payloadData?.search}`
    } else{
      url = `${env}${API_ENDPOINT.operations.availableVehicleApi}?tripId=${payload}`
    }
    const res = await requestInstance
      .get(url).catch((err) => err.response);
    return setCurrentUser(res);
  };

  export const availableSupplierService = async (payload) => {
    const payloadData = {
      search: payload?.search || "",
      id:  payload?.id,
    };

    let url = "";
    if(payload?.id){
      url = `${env}${API_ENDPOINT.operations.availableSuppliersApi}?tripId=${payloadData?.id}&search=${payloadData?.search}`
    } else{
      url = `${env}${API_ENDPOINT.operations.availableSuppliersApi}?tripId=${payload}`
    }
    const res = await requestInstance
      .get(url).catch((err) => err.response);
    return setCurrentUser(res);
  };
